import { crudActions } from "./CrudActions"

export default {
  ...crudActions("elements-tecnics-tactics"),
}
